import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgSelectModule} from '@ng-select/ng-select';
import {FileUploadModule} from 'ng2-file-upload';
import {ImageCropperModule} from 'ngx-image-cropper';
import {ListActivityLogsPageComponent} from './list-activity-logs/list-activity-logs-page.component';
import {ActivityLogService} from './activity-log/activity-log-service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgbModule,
        NgxDatatableModule,
        NgSelectModule,
        FileUploadModule,
        ImageCropperModule
    ],
    declarations: [
        ListActivityLogsPageComponent
    ],
    exports: [
        ListActivityLogsPageComponent
    ],
    providers: [
        ActivityLogService
    ]
})
export class OkActivityLogModule {
}
